module.exports = __webpack_public_path__ + "static/1-b5803ad8161f600966d3df9259f95a13.jpg";